import FunctionHeader from "presentation/components/Header/FunctionHeader";
import PurchaseOrderForm from "presentation/components/PurchaseOrder/PurchaseOrderForm";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useParams } from "react-router-dom";

const ProjectFormPage = () => {
  const { id } = useParams();
  const { isLoading } = usePermissionCheck({
    requiredFunction: "purchaseOrders",
  });

  if (isLoading) {
    return <Spinner />;
  }
  const isEditing = !!id;

  const title = isEditing ? "Editar Ordem de Compra" : "Criar Ordem de Compra";
  return (
    <div>
      <FunctionHeader title={title} />
      <PurchaseOrderForm />
    </div>
  );
};

export default ProjectFormPage;
